import { DashboardLayout } from "../components/dashboard/dashboard-layout";
import { PageHeader } from "../components/dashboard/page-header";
import { 
  Percent, 
  Tag, 
  Users, 
  TrendingUp,
  Clock,
  Settings,
  Plus,
  ArrowUpRight,
  Zap,
  Calendar,
  Target,
  ShoppingCart
} from "lucide-react";

export default function DiscountManagerPage() {
  return (
    <DashboardLayout>
      <PageHeader 
        title="Discount Manager" 
        description="Create and manage discount codes and promotional campaigns"
      />
      
      {/* Coming Soon Hero Section */}
      <div className="text-center py-16 mb-8">
        <div className="max-w-2xl mx-auto">
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gray-100 dark:bg-gray-800 mb-6">
              <Percent className="h-10 w-10 text-gray-500 dark:text-gray-400" />
            </div>
            <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-gray-100">Coming Soon</h1>
            <p className="text-xl text-gray-500 dark:text-gray-400 mb-8">
              We're developing a comprehensive discount management system to help you create, track, and optimize promotional campaigns.
            </p>
          </div>
          
          <div className="grid gap-6 md:grid-cols-3 mb-12">
            <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-800 p-6">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-gray-100 dark:bg-gray-800 mb-4 mx-auto">
                <Tag className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-gray-100">Discount Codes</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Generate and manage percentage, fixed amount, and BOGO discount codes with custom rules.
              </p>
            </div>
            
            <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-800 p-6">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-gray-100 dark:bg-gray-800 mb-4 mx-auto">
                <Calendar className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-gray-100">Campaign Scheduling</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Schedule promotional campaigns with start/end dates and automatic activation.
              </p>
            </div>
            
            <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-800 p-6">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-gray-100 dark:bg-gray-800 mb-4 mx-auto">
                <Target className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-gray-100">Performance Tracking</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Monitor discount usage, conversion rates, and revenue impact with detailed analytics.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Preview Stats Cards */}
      <div className="grid gap-4 sm:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mb-8">
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 p-5">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Active Discounts</h3>
            <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-800">
              <Tag className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            </div>
          </div>
          <div className="flex items-baseline">
            <span className="text-3xl font-bold text-gray-900 dark:text-gray-100">--</span>
            <span className="ml-2 text-sm font-medium flex items-center text-gray-400">
              <ArrowUpRight className="h-3 w-3 mr-1" />
              Coming Soon
            </span>
          </div>
          <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Currently running campaigns</div>
        </div>
        
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 p-5">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Total Savings</h3>
            <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-800">
              <Percent className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            </div>
          </div>
          <div className="flex items-baseline">
            <span className="text-3xl font-bold text-gray-900 dark:text-gray-100">--</span>
            <span className="ml-2 text-sm font-medium flex items-center text-gray-400">
              <ArrowUpRight className="h-3 w-3 mr-1" />
              Coming Soon
            </span>
          </div>
          <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Customer savings this month</div>
        </div>
        
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 p-5">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Code Usage</h3>
            <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-800">
              <ShoppingCart className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            </div>
          </div>
          <div className="flex items-baseline">
            <span className="text-3xl font-bold text-gray-900 dark:text-gray-100">--</span>
            <span className="ml-2 text-sm font-medium flex items-center text-gray-400">
              <ArrowUpRight className="h-3 w-3 mr-1" />
              Coming Soon
            </span>
          </div>
          <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Discount codes redeemed</div>
        </div>
        
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 p-5">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Conversion Rate</h3>
            <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-800">
              <TrendingUp className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            </div>
          </div>
          <div className="flex items-baseline">
            <span className="text-3xl font-bold text-gray-900 dark:text-gray-100">--</span>
            <span className="ml-2 text-sm font-medium flex items-center text-gray-400">
              <ArrowUpRight className="h-3 w-3 mr-1" />
              Coming Soon
            </span>
          </div>
          <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Discount to purchase rate</div>
        </div>
      </div>

      {/* Feature Preview Cards */}
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 hover:shadow-md transition-all duration-200">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 rounded-full bg-gray-100 dark:bg-gray-800">
                <Zap className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400">
                Coming Soon
              </span>
            </div>
            <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-gray-100">Smart Campaigns</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
              AI-powered discount recommendations based on customer behavior and market trends.
            </p>
            <div className="flex items-center text-sm text-gray-400">
              <Clock className="h-4 w-4 mr-2" />
              <span>In Development</span>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 hover:shadow-md transition-all duration-200">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 rounded-full bg-gray-100 dark:bg-gray-800">
                <Settings className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400">
                Coming Soon
              </span>
            </div>
            <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-gray-100">Advanced Rules</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
              Set complex discount rules with customer segments, product categories, and usage limits.
            </p>
            <div className="flex items-center text-sm text-gray-400">
              <Clock className="h-4 w-4 mr-2" />
              <span>In Development</span>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm overflow-hidden border border-gray-200 dark:border-gray-800 hover:shadow-md transition-all duration-200">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 rounded-full bg-gray-100 dark:bg-gray-800">
                <Plus className="h-6 w-6 text-gray-500 dark:text-gray-400" />
              </div>
              <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400">
                Coming Soon
              </span>
            </div>
            <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-gray-100">Multi-Platform Sync</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
              Synchronize discount codes across all your sales channels and platforms automatically.
            </p>
            <div className="flex items-center text-sm text-gray-400">
              <Clock className="h-4 w-4 mr-2" />
              <span>In Development</span>
            </div>
          </div>
        </div>
      </div>

      {/* Notification Banner */}
      <div className="mt-8 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
        <div className="flex items-start gap-4">
          <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-800">
            <Percent className="h-5 w-5 text-gray-500 dark:text-gray-400" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold mb-2 text-gray-900 dark:text-gray-100">Get Notified When Available</h4>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
              Be the first to access our powerful discount management tools. We're creating the most intuitive promotional campaign system.
            </p>
            <button className="px-4 py-2 bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 rounded-lg text-sm font-medium hover:bg-gray-800 dark:hover:bg-white transition-all duration-200">
              Notify Me
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
